<pos-app-spinner [show]="isBusy"></pos-app-spinner>
<div *ngIf="role$ | async as role" style="margin-top: 140px">
  <div *ngIf="loggedinUserId$ | async as loggedInUserId">
    <div *ngIf="hoverStatus" class="fab-container" (click)="setDisplayPreference(true, 'MIN')" style="margin-left: 10px">
      <div class="fab">
        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="28px" fill="#ffffff">
          <path d="M440-280v-400L240-480l200 200Zm80 160h80v-720h-80v720Z" />
        </svg>
      </div>
    </div>
    <div *ngIf="!hoverStatus" class="fab-container" style="left: 48px" (click)="setDisplayPreference(true, 'MAX')">
      <div class="fab">
        <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="28px" fill="#ffffff">
          <path d="M360-120v-720h80v720h-80Zm160-160v-400l200 200-200 200Z" />
        </svg>
      </div>
    </div>
    <span class="nav-item-border"></span>
    <div *ngIf="activeOrder?.orderNumber">
      <div *ngIf="activeOrder?.orderNumber" class="nav-item">
        <a (click)="viewOrder()" title="{{ openOrder.customerName }}">
          <span style="color: white"><mat-icon>shopping_cart</mat-icon></span>
          <span *ngIf="hoverStatus" class="label-text">View Order</span></a
        >
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">View Order</span>
      </div>
    </div>
    <div *ngIf="isCashDrawer && defaultBranch$ | async as branch" class="sidenav d-flex align-items-center nav-item">
      <a (click)="quickSale(branch)" routerLinkActive="active">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M280-640q-33 0-56.5-23.5T200-720v-80q0-33 23.5-56.5T280-880h400q33 0 56.5 23.5T760-800v80q0 33-23.5 56.5T680-640H280Zm0-80h400v-80H280v80ZM160-80q-33 0-56.5-23.5T80-160v-40h800v40q0 33-23.5 56.5T800-80H160ZM80-240l139-313q10-22 30-34.5t43-12.5h376q23 0 43 12.5t30 34.5l139 313H80Zm260-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm120 160h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm120 160h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Zm0-80h40q8 0 14-6t6-14q0-8-6-14t-14-6h-40q-8 0-14 6t-6 14q0 8 6 14t14 6Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Quick Sale </span></a
      >
      <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Quick Sale</span>
      <!-- </div> -->
    </div>
    <span class="nav-item-border"></span>
    <div *ngIf="arbCentralSecurityFunctions?.showOrderActionsTF">
      <div class="d-flex align-items-center nav-item" (click)="newOrder()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M280-160v-441q0-33 24-56t57-23h439q33 0 56.5 23.5T880-600v320L680-80H360q-33 0-56.5-23.5T280-160ZM81-710q-6-33 13-59.5t52-32.5l434-77q33-6 59.5 13t32.5 52l10 54h-82l-7-40-433 77 40 226v279q-16-9-27.5-24T158-276L81-710Zm279 110v440h280l160-160v-280H360Zm220 220Zm-40 160h80v-120h120v-80H620v-120h-80v120H420v80h120v120Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">New Order / Quotes</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">New Order / Quotes</span>
      </div>
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/pos/my-orders/current', false, true)">
        <div class="" (click)="navigateTo('/pos/my-orders/current', false, true)" routerLinkActive="active" style="margin-left: -12px">
          <span [matBadge]="parkedOrderListLength" style="margin-right: 14px; padding-bottom: 4px"> </span>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
            <path
              d="M440-200h80v-40h40q17 0 28.5-11.5T600-280v-120q0-17-11.5-28.5T560-440H440v-40h160v-80h-80v-40h-80v40h-40q-17 0-28.5 11.5T360-520v120q0 17 11.5 28.5T400-360h120v40H360v80h80v40ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-560v-160H240v640h480v-480H520ZM240-800v160-160 640-640Z"
            />
          </svg>
        </div>
        <span *ngIf="hoverStatus" class="label-text">My Recent Orders</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">My Recent Orders</span>
      </div>
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/pos/my-orders/quotes', false, false)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M80-160v-640h800v640H80Zm80-80h640v-480H160v480Zm0 0v-480 480Zm160-40h80v-40h40q17 0 28.5-11.5T480-360v-120q0-17-11.5-28.5T440-520H320v-40h160v-80h-80v-40h-80v40h-40q-17 0-28.5 11.5T240-600v120q0 17 11.5 28.5T280-440h120v40H240v80h80v40Zm320-30 80-80H560l80 80Zm-80-250h160l-80-80-80 80Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Open Quotes</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Open Quotes</span>
      </div>
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/pos/my-orders/arb-orders', false, false)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M80-160v-640h800v640H80Zm80-80h640v-480H160v480Zm0 0v-480 480Zm160-40h80v-40h40q17 0 28.5-11.5T480-360v-120q0-17-11.5-28.5T440-520H320v-40h160v-80h-80v-40h-80v40h-40q-17 0-28.5 11.5T240-600v120q0 17 11.5 28.5T280-440h120v40H240v80h80v40Zm320-30 80-80H560l80 80Zm-80-250h160l-80-80-80 80Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Open ARB orders</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Open ARB orders</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.jobRequestActionTF" (click)="navigateTo('/pos/my-orders/pos-arb-orders', false, false)">
      <div class="nav-item">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M160-200v-15 15-440 440Zm0 80q-33 0-56.5-23.5T80-200v-440q0-33 23.5-56.5T160-720h160v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h160q33 0 56.5 23.5T880-640v171q-18-13-38-22.5T800-508v-132H160v440h283q3 21 9 41t15 39H160Zm240-600h160v-80H400v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm0-80 120-120-28-28-72 72v-164h-40v164l-72-72-28 28 120 120Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Job Requests </span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Job Requests</span>
      </div>
    </div>
    <span class="nav-item-border"></span>
    <div *ngIf="arbCentralSecurityFunctions?.manageTicketsActionTF">
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/central/tasks', false, false)">
        <span
          *ngIf="(centralTaskData$ | async)?.MyOverdueTotal > 0"
          [matBadge]="(centralTaskData$ | async)?.MyOverdueTotal"
          style="margin-left: -16px; margin-top: -20px; margin-right: 14px; padding-bottom: 4px"
          title="My Overdue Total"
        >
        </span>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M222-200 80-342l56-56 85 85 170-170 56 57-225 226Zm0-320L80-662l56-56 85 85 170-170 56 57-225 226Zm298 240v-80h360v80H520Zm0-320v-80h360v80H520Z"
          />
        </svg>
        <span
          *ngIf="(centralTaskData$ | async)?.UnassignedTicketsTotal > 0"
          class="custom-badge"
          [matBadge]="(centralTaskData$ | async)?.UnassignedTicketsTotal"
          matBadgeColor="warn"
          style="margin-top: -20px; margin-left: -4px; margin-right: 14px; padding-bottom: 4px"
          title="Unassigned Tasks"
        ></span>
        <span *ngIf="hoverStatus" class="label-text m-2">Manage Tasks</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus m-2">Manage Tasks</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.productCatalogueActionTF">
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/epc', false, false)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M160-80q-33 0-56.5-23.5T80-160v-640q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v640q0 33-23.5 56.5T800-80H160Zm0-80h640v-640H160v640Zm200-240q-17 0-28.5-11.5T320-440q0-17 11.5-28.5T360-480q17 0 28.5 11.5T400-440q0 17-11.5 28.5T360-400Zm240 0q-17 0-28.5-11.5T560-440q0-17 11.5-28.5T600-480q17 0 28.5 11.5T640-440q0 17-11.5 28.5T600-400ZM200-516v264q0 14 9 23t23 9h16q14 0 23-9t9-23v-48h400v48q0 14 9 23t23 9h16q14 0 23-9t9-23v-264l-66-192q-5-14-16.5-23t-25.5-9H308q-14 0-25.5 9T266-708l-66 192Zm106-64 28-80h292l28 80H306ZM160-800v640-640Zm120 420v-120h400v120H280Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Product Catalogue</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Product Catalogue</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.itemPriceSearchActionTF">
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/stock/search', false, false)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="m105-399-65-47 200-320 120 140 160-260 120 180 135-214 65 47-198 314-119-179-152 247-121-141-145 233Zm475 159q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29ZM784-80 676-188q-21 14-45.5 21t-50.5 7q-75 0-127.5-52.5T400-340q0-75 52.5-127.5T580-520q75 0 127.5 52.5T760-340q0 26-7 50.5T732-244l108 108-56 56Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Item Price Search</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Item Price Search</span>
      </div>
    </div>

    <div *ngIf="arbCentralSecurityFunctions?.customerSearchActionTF">
      <div class="d-flex align-items-center nav-item" (click)="navigateTo('/pos/customers/search', false, false)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M440-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T520-640q0-33-23.5-56.5T440-720q-33 0-56.5 23.5T360-640q0 33 23.5 56.5T440-560ZM884-20 756-148q-21 12-45 20t-51 8q-75 0-127.5-52.5T480-300q0-75 52.5-127.5T660-480q75 0 127.5 52.5T840-300q0 27-8 51t-20 45L940-76l-56 56ZM660-200q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-540 40v-111q0-34 17-63t47-44q51-26 115-44t142-18q-12 18-20.5 38.5T407-359q-60 5-107 20.5T221-306q-10 5-15.5 14.5T200-271v31h207q5 22 13.5 42t20.5 38H120Zm320-480Zm-33 400Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Customer</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Customer</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.workshopBookingActionTF">
      <div class="d-flex align-items-center nav-item" (click)="goToScheduler()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M42-120v-112q0-33 17-62t47-44q51-26 115-44t141-18q77 0 141 18t115 44q30 15 47 44t17 62v112H42Zm80-80h480v-32q0-11-5.5-20T582-266q-36-18-92.5-36T362-320q-71 0-127.5 18T142-266q-9 5-14.5 14t-5.5 20v32Zm240-240q-66 0-113-47t-47-113h-10q-9 0-14.5-5.5T172-620q0-9 5.5-14.5T192-640h10q0-45 22-81t58-57v38q0 9 5.5 14.5T302-720q9 0 14.5-5.5T322-740v-54q9-3 19-4.5t21-1.5q11 0 21 1.5t19 4.5v54q0 9 5.5 14.5T422-720q9 0 14.5-5.5T442-740v-38q36 21 58 57t22 81h10q9 0 14.5 5.5T552-620q0 9-5.5 14.5T532-600h-10q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T442-600H282q0 33 23.5 56.5T362-520Zm300 160-6-30q-6-2-11.5-4.5T634-402l-28 10-20-36 22-20v-24l-22-20 20-36 28 10q4-4 10-7t12-5l6-30h40l6 30q6 2 12 5t10 7l28-10 20 36-22 20v24l22 20-20 36-28-10q-5 5-10.5 7.5T708-390l-6 30h-40Zm20-70q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm72-130-8-42q-9-3-16.5-7.5T716-620l-42 14-28-48 34-30q-2-5-2-8v-16q0-3 2-8l-34-30 28-48 42 14q6-6 13.5-10.5T746-798l8-42h56l8 42q9 3 16.5 7.5T848-780l42-14 28 48-34 30q2 5 2 8v16q0 3-2 8l34 30-28 48-42-14q-6 6-13.5 10.5T818-602l-8 42h-56Zm28-90q21 0 35.5-14.5T832-700q0-21-14.5-35.5T782-750q-21 0-35.5 14.5T732-700q0 21 14.5 35.5T782-650ZM362-200Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Workshop Booking</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Workshop Booking</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.arbAccountsActionTF && { value: defaultCustomer$ | async } as customer">
      <div class="nav-item" (click)="navigateToAccountUser(customer.value.customerNumber)" routerLinkActive="active">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M200-200v-560 560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v100h-80v-100H200v560h560v-100h80v100q0 33-23.5 56.5T760-120H200Zm320-160q-33 0-56.5-23.5T440-360v-240q0-33 23.5-56.5T520-680h280q33 0 56.5 23.5T880-600v240q0 33-23.5 56.5T800-280H520Zm280-80v-240H520v240h280Zm-160-60q25 0 42.5-17.5T700-480q0-25-17.5-42.5T640-540q-25 0-42.5 17.5T580-480q0 25 17.5 42.5T640-420Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">ARB Accounts </span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">ARB Accounts</span>
      </div>
    </div>
    <span class="nav-item-border"></span>
    <div>
      <div class="nav-item" routerLinkActive="active" (click)="isFeedback = true">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M80-80v-80q46 0 91-6t88-22q-46-23-72.5-66.5T160-349v-91h160v-120h135L324-822l72-36 131 262q20 40-3 78t-68 38h-56v40q0 33-23.5 56.5T320-360h-80v11q0 35 21.5 61.5T316-252l12 3q40 10 45 50t-31 60q-60 33-126.5 46T80-80Zm572-114-57-56q21-21 33-48.5t12-59.5q0-32-12-59.5T595-466l57-57q32 32 50 74.5t18 90.5q0 48-18 90t-50 74ZM765-80l-57-57q43-43 67.5-99.5T800-358q0-66-24.5-122T708-579l57-57q54 54 84.5 125T880-358q0 81-30.5 152.5T765-80Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Feedback</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Feedback</span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions && showAdminFunctions">
      <div class="btn-custom nav-item" (click)="toggleShowAccountSubMenu()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M680-280q25 0 42.5-17.5T740-340q0-25-17.5-42.5T680-400q-25 0-42.5 17.5T620-340q0 25 17.5 42.5T680-280Zm0 120q31 0 57-14.5t42-38.5q-22-13-47-20t-52-7q-27 0-52 7t-47 20q16 24 42 38.5t57 14.5ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v227q-19-8-39-14.5t-41-9.5v-147l-240-90-240 90v188q0 47 12.5 94t35 89.5Q310-290 342-254t71 60q11 32 29 61t41 52q-1 0-1.5.5t-1.5.5Zm200 0q-83 0-141.5-58.5T480-280q0-83 58.5-141.5T680-480q83 0 141.5 58.5T880-280q0 83-58.5 141.5T680-80ZM480-494Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text"
          >Admin Functions
          <svg *ngIf="!isShowArbAccountSubMenu" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
            <path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z" />
          </svg>
        </span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Admin Functions</span>
        <span>
          <mat-icon *ngIf="isShowArbAccountSubMenu" class="text-white mt-4">arrow_drop_up</mat-icon>
        </span>
      </div>
      <div *ngIf="isShowArbAccountSubMenu" class="mx-2" style="background-color: #8b8989">
        <div
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/register')"
          *ngIf="arbCentralSecurityFunctions?.registerAdminActionTF"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M240-160q-33 0-56.5-23.5T160-240q0-33 23.5-56.5T240-320q33 0 56.5 23.5T320-240q0 33-23.5 56.5T240-160Zm0-240q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm0-240q-33 0-56.5-23.5T160-720q0-33 23.5-56.5T240-800q33 0 56.5 23.5T320-720q0 33-23.5 56.5T240-640Zm240 0q-33 0-56.5-23.5T400-720q0-33 23.5-56.5T480-800q33 0 56.5 23.5T560-720q0 33-23.5 56.5T480-640Zm240 0q-33 0-56.5-23.5T640-720q0-33 23.5-56.5T720-800q33 0 56.5 23.5T800-720q0 33-23.5 56.5T720-640ZM480-400q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm40 240v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T863-380L643-160H520Zm300-263-37-37 37 37ZM580-220h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1">Register Admin</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Register Admin</span>
        </div>
        <div class="nav-item-sub" *ngIf="arbCentralSecurityFunctions?.partnerPartsActionTF">
          <span *ngIf="hoverStatus" class="mx-2"> Partner Parts</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Partner Parts</span>
          <span [ngStyle]="{ 'margin-left': !hoverStatus ? '-4px' : '' }">
            <label class="switch">
              <input type="checkbox" (change)="toggleXRefPart($event.target.checked)" [checked]="isXRefPartsView" />
              <span class="slider round"></span>
            </label>
          </span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.manageInternalUsersActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/manageusers/internal')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H80Zm560 40-12-60q-12-5-22.5-10.5T584-204l-58 18-40-68 46-40q-2-14-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T628-460l12-60h80l12 60q12 5 22.5 11t21.5 15l58-20 40 70-46 40q2 12 2 25t-2 25l46 40-40 68-58-18q-11 8-21.5 13.5T732-180l-12 60h-80Zm40-120q33 0 56.5-23.5T760-320q0-33-23.5-56.5T680-400q-33 0-56.5 23.5T600-320q0 33 23.5 56.5T680-240ZM400-560q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Zm0-80Zm12 400Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1">Manage Internal Users</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus"> Manage Internal Users</span>
        </div>

        <div
          *ngIf="arbCentralSecurityFunctions?.manageRegisteredUsersActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/manageusers/external')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M680-119q-8 0-16-2t-15-7l-120-70q-14-8-21.5-21.5T500-249v-141q0-16 7.5-29.5T529-441l120-70q7-5 15-7t16-2q8 0 15.5 2.5T710-511l120 70q14 8 22 21.5t8 29.5v141q0 16-8 29.5T830-198l-120 70q-7 4-14.5 6.5T680-119ZM400-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM80-160v-112q0-33 17-62t47-44q51-26 115-44t141-18h14q6 0 12 2-8 18-13.5 37.5T404-360h-4q-71 0-127.5 18T180-306q-9 5-14.5 14t-5.5 20v32h252q6 21 16 41.5t22 38.5H80Zm320-400q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Zm0-80Zm12 400Zm174-166 94 55 94-55-94-54-94 54Zm124 208 90-52v-110l-90 53v109Zm-150-52 90 53v-109l-90-53v109Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1"> Manage Registered Users</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Manage Registered Users</span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.managePartnersActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/partner/manage')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M480-600 340-740l140-140 140 140-140 140ZM40-160v-160q0-34 23.5-57t56.5-23h131q20 0 38 10t29 27q29 39 71.5 61t90.5 22q49 0 91.5-22t70.5-61q13-17 30.5-27t36.5-10h131q34 0 57 23t23 57v160H640v-91q-35 25-75.5 38T480-200q-43 0-84-13.5T320-252v92H40Zm120-280q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T280-560q0 50-34.5 85T160-440Zm640 0q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T920-560q0 50-34.5 85T800-440Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1">Manage Partner</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus"> Manage Partner</span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.impersonatePartnerActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="impersonatePartner()"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
            <path
              d="M480-880q50 0 85 35t35 85q0 50-35 85t-85 35q-50 0-85-35t-35-85q0-50 35-85t85-35Zm0 280q47 0 93 11t83 31q38 19 61 45t23 57v232q0 17-8 33.5T710-160q-14 14-32.5 26T636-112v-90q0-38-52.5-62T480-288q-50 0-96.5 20.5T326-214q38 15 78 21t82 7h34v104q-7 2-14.5 2H490q-36 0-82.5-8T319-113q-42-17-70.5-44.5T220-224v-232q0-31 23-57t60-45q38-20 84-31t93-11Zm0 240q33 0 56.5-23.5T560-440q0-33-23.5-56.5T480-520q-33 0-56.5 23.5T400-440q0 33 23.5 56.5T480-360Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1">Impersonate Partner</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus"> Impersonate Partner</span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.manageShowUsersActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/manageusers/show')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M160-80q-33 0-56.5-23.5T80-160v-440q0-33 23.5-56.5T160-680h200v-120q0-33 23.5-56.5T440-880h80q33 0 56.5 23.5T600-800v120h200q33 0 56.5 23.5T880-600v440q0 33-23.5 56.5T800-80H160Zm0-80h640v-440H600q0 33-23.5 56.5T520-520h-80q-33 0-56.5-23.5T360-600H160v440Zm80-80h240v-18q0-17-9.5-31.5T444-312q-20-9-40.5-13.5T360-330q-23 0-43.5 4.5T276-312q-17 8-26.5 22.5T240-258v18Zm320-60h160v-60H560v60Zm-200-60q25 0 42.5-17.5T420-420q0-25-17.5-42.5T360-480q-25 0-42.5 17.5T300-420q0 25 17.5 42.5T360-360Zm200-60h160v-60H560v60ZM440-600h80v-200h-80v200Zm40 220Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1"> Manage Show Users</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus"> Manage Show Users</span>
        </div>

        <div
          *ngIf="arbCentralSecurityFunctions?.manageRelatedSitesActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/central/manage/how-to-help-component')"
        >
          <mat-icon class="text-white">language</mat-icon>
          <span *ngIf="hoverStatus" class="ps-1"> Manage Related Sites</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus"> Manage Related Sites</span>
        </div>

        <span class="nav-item-border mx-2"></span>
      </div>
    </div>

    <div *ngIf="arbCentralSecurityFunctions">
      <div class="btn-custom nav-item text-white" (click)="togglePreferences()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text"
          >Preferences
          <svg
            *ngIf="!isShowPreferencesSubMenu"
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#ffffff"
          >
            <path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z" />
          </svg>
        </span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Preferences</span>
        <span>
          <mat-icon *ngIf="isShowPreferencesSubMenu" class="text-white mt-4">arrow_drop_up</mat-icon>
        </span>
      </div>
      <div *ngIf="isShowPreferencesSubMenu" class="mx-2">
        <div *ngIf="arbCentralSecurityFunctions?.showroomViewActionTF" class="nav-item-sub">
          <span *ngIf="hoverStatus" class="mx-2"> Showroom View </span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Showroom View </span>
          <span [ngStyle]="{ 'margin-left': !hoverStatus ? '-4px' : '' }">
            <label class="switch">
              <input type="checkbox" (change)="toggleShowroom($event.target.checked)" [checked]="isShowroomView" />
              <span class="slider round"></span>
            </label>
          </span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.manageMyProfileActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="navigateTo('/pos/manageusers/profile')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF">
            <path
              d="M200-246q54-53 125.5-83.5T480-360q83 0 154.5 30.5T760-246v-514H200v514Zm280-194q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm69-80h422q-44-39-99.5-59.5T480-280q-56 0-112.5 20.5T269-200Zm211-320q-25 0-42.5-17.5T420-580q0-25 17.5-42.5T480-640q25 0 42.5 17.5T540-580q0 25-17.5 42.5T480-520Zm0 17Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1"> Manage My Profile </span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Manage My Profile </span>
        </div>
        <div
          *ngIf="arbCentralSecurityFunctions?.resetPasswordActionTF"
          class="nav-item-sub"
          [ngStyle]="{ 'justify-content': hoverStatus ? 'left' : 'center' }"
          (click)="resetPassword(loggedInUserId)"
        >
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
            <path
              d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480h80q0 66 25 124.5t68.5 102q43.5 43.5 102 69T480-159q134 0 227-93t93-227q0-134-93-227t-227-93q-89 0-161.5 43.5T204-640h116v80H80v-240h80v80q55-73 138-116.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-80-240q-17 0-28.5-11.5T360-360v-120q0-17 11.5-28.5T400-520v-40q0-33 23.5-56.5T480-640q33 0 56.5 23.5T560-560v40q17 0 28.5 11.5T600-480v120q0 17-11.5 28.5T560-320H400Zm40-200h80v-40q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560v40Z"
            />
          </svg>
          <span *ngIf="hoverStatus" class="ps-1"> Reset Password</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Reset Password</span>
        </div>
        <span class="nav-item-border mx-2"></span>
      </div>
    </div>
    <div *ngIf="arbCentralSecurityFunctions?.switchUserActionTF">
      <div class="d-flex align-items-center nav-item" (click)="switchUser()">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
          <path
            d="M680-360q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM480-160v-56q0-24 12.5-44.5T528-290q36-15 74.5-22.5T680-320q39 0 77.5 7.5T832-290q23 9 35.5 29.5T880-216v56H480Zm-80-320q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-160ZM80-160v-112q0-34 17-62.5t47-43.5q60-30 124.5-46T400-440q35 0 70 6t70 14l-34 34-34 34q-18-5-36-6.5t-36-1.5q-58 0-113.5 14T180-306q-10 5-15 14t-5 20v32h240v80H80Zm320-80Zm0-320q33 0 56.5-23.5T480-640q0-33-23.5-56.5T400-720q-33 0-56.5 23.5T320-640q0 33 23.5 56.5T400-560Z"
          />
        </svg>
        <span *ngIf="hoverStatus" class="label-text">Switch User</span>
        <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Switch User</span>
      </div>
    </div>
    <div>
      <div class="" (click)="logout()" style="padding-bottom: 20px; height: 80px">
        <div class="d-flex align-items-center nav-item">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff">
            <path
              d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"
            />
          </svg>
          <span *ngIf="hoverStatus">Logout</span>
          <span *ngIf="!hoverStatus" class="label-text-hoverStatus">Logout</span>
        </div>
        <span class="nav-item-border"></span>
      </div>
    </div>
  </div>
  <pos-app-feedback
    *ngIf="isFeedback"
    (closeFeedback)="isFeedback = false"
    [isExternalUser]="!forInternalUser(role)"
    [customerDetails]="defaultCustomer$ | async"
  >
  </pos-app-feedback>
  <central-app-impersonate-partner *ngIf="isImpersonatePartner"   (closeModal)="isImpersonatePartner = false"> </central-app-impersonate-partner>
</div>
